const isObjectLike = require('lodash/isObjectLike')

/*
 * recursively loops through a deep structure and runs a callback
 * function every time it arrives at a final value, final value in
 * this context meaning a value that doesn't further nest, essentially
 * primitive values
 *
 * the callback is passed the value as well as the path to the value in
 * the format of an array of property strings
 * 
 * const structure = { a: 'foo', b: { c: 'bar', d: 'baz' } }
 *
 * deepForEach(structure, console.log)
 *
 * logs:
 * foo [ 'a' ]
 * bar [ 'b' , 'c' ]
 * baz [ 'b', 'd' ]
 */
function deepForEach (deepStructure, callback) {
  function recurse (partialStructure, path) {
    const entries = Object.entries(partialStructure)

    for (const [ key, entry ] of entries) {
      if (isObjectLike(entry)) {
        recurse(entry, [ ...path, key ])
      } else {
        callback(entry, [ ...path, key ])
      }
    }
  }

  return recurse(deepStructure, [])
}

module.exports = deepForEach
